import { render, staticRenderFns } from "./row-buttons.vue?vue&type=template&id=3c986b6e&"
import script from "./row-buttons.vue?vue&type=script&lang=js&"
export * from "./row-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports